import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useSEO } from "@/hooks/useSEO";

const NotFound = () => {
  const location = useLocation();

  useSEO({
    title: "404, puslapis nerastas | apeXride Racing",
    description:
      "Šio puslapio nėra. Grįžkite į apeXride Racing pradžią ir susipažinkite su Junior Rally Academy programa.",
    path: location.pathname,
    image: "https://apexride.racing/og-racing.jpg",
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] text-white">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-white/80">Puslapis nerastas</p>
        <Link to="/" className="text-primary underline hover:opacity-80">
          Grįžti į pradžią
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
